<template>
    <div id="headerOptions" tabindex="1">
        <div class="options">
            <div
                class="row-item"
                v-if="!connected && !ticketMode && pageIndex !== 3 && settings.ticketShow"
                key="1"
                @click="() => emitFunc('showTicketForm', true)"
            >
                <div class="svg-wrapper">
                    <DynamicSvg :name="'LeaveMessage'" />
                </div>
                <div class="text-wrapper">
                    {{ $t("message.createTicket") }}
                </div>
            </div>
            <div class="row-item" v-if="isCatalogOpen && loginFormRequired" @click="openFullscreen">
                <div class="svg-wrapper">
                    <DynamicSvg :name="'CatalogIcon'" />
                </div>
                <div class="text-wrapper">
                    {{ settings.catalogMenuTitle || $t("message.catalog") }}
                </div>
            </div>
            <div class="row-item" @click="emitFunc('deleteKVKK', true)" v-if="visitorGDPRDeleteEnabled">
                <div class="svg-wrapper">
                    <DynamicSvg :name="'DeleteInfo'" />
                </div>
                <div class="text-wrapper">
                    {{ $t("message.deleteKVVK") }}
                </div>
            </div>
            <div class="row-item">
                <div class="svg-wrapper">
                    <DynamicSvg :name="'Bell'" />
                </div>
                <div class="volume-switch">
                    <a-slider
                        v-model="newVolume"
                        @blur="() => emitFunc('localVolume', false, newVolume)"
                        :tooltipVisible="false"
                        :min="0"
                        :max="100"
                    />
                </div>
            </div>
            <div class="row-item" @click="changePageIndex(3, true)">
                <div class="svg-wrapper">
                    <DynamicSvg :name="'Refresh'" />
                </div>
                <div class="text-wrapper">
                    {{ $t("message.chatHistory") }}
                </div>
            </div>
            <div v-if="isIframeMode() && isMaximizeEnabled()" class="row-item" @click="emitFunc('maximize', true)">
                <div class="svg-wrapper">
                    <DynamicSvg :name="'Zoom'" />
                </div>
                <div class="text-wrapper">
                    {{ $t("message.maximize") }}
                </div>
            </div>
            <div class="row-item" v-if="settings.autoTranslate">
                <div class="svg-wrapper">
                    <DynamicSvg :name="'AutoTranslate'" />
                </div>
                <div class="text-wrapper">{{ $t("message.autoTranslate") }}</div>
                <div class="switcher-container">
                    <a-switch
                        class="ml-2 mr-2"
                        size="small"
                        v-model="isOpenedAutoTranslate"
                        @change="toggleAutoTranslate"
                    />
                </div>
            </div>
            <div v-if="settings.languageShow" class="row-item" @click="() => changePageIndex(4, true)">
                <div class="svg-wrapper">
                    <DynamicSvg :name="'Language'" :color="'#A3A8A8'" />
                </div>
                <div class="text-wrapper">{{ $t("message.selectChatLang") }}</div>
            </div>
            <div v-if="connected" class="row-item" @click="emitFunc('closeChat', true)">
                <div class="svg-wrapper">
                    <DynamicSvg :name="'Cancel'" :color="'#A2A8A8'" />
                </div>
                <div class="text-wrapper">{{ $t("message.closeChat") }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import DynamicSvg from "../../../common/DynamicSvg.vue";
import log2 from "../../../utils/log2";

const log = log2("HeaderOptions");
export default {
    components: { DynamicSvg },
    name: "HeaderOptions",
    props: ["volume", "ticketMode", "connected", "visitorGDPRDeleteEnabled", "isIframeMode"],
    data() {
        return {
            isOpenedAutoTranslate: false,
            newVolume: this.volume,
            cancels: [],
        };
    },
    methods: {
        ...mapMutations({
            CHANGE_PAGE: "app/CHANGE_PAGE",
            changeAutoTranslate: "chat/SET_AUTO_TRANSLATE",
        }),
        isMaximizeEnabled() {
            // log("isIframeMode", window.parent !== window, window.parent != window);
            const disabledSiteIds = [
                "6423065cd13386cb77688696", // betnano
                // "5d14ee322d95ad001ebdf213", // betnano
            ];
            if (disabledSiteIds.includes(_.get(this.site, "_id"))) return false;

            return true;
        },
        emitFunc(name, isClosed, parameter = null) {
            this.$emit(name, parameter && parameter);
            if (isClosed) {
                return this.$emit("closePopup");
            }
        },
        changePageIndex(index, isClosedPopup) {
            this.CHANGE_PAGE(index);
            if (isClosedPopup) {
                return this.$emit("closePopup");
            }
        },
        mouseEvent() {
            const cb = (e) => {
                if (
                    e.target.offsetParent !== null &&
                    e.target.offsetParent !== undefined &&
                    !document.getElementById("headerOptions").contains(e.target)
                ) {
                    this.$emit("closePopup");
                }
            };
            window.addEventListener("click", cb);
            this.cancels.push(() => {
                window.removeEventListener("click", cb);
            });
        },
        toggleAutoTranslate() {
            this.changeAutoTranslate(this.isOpenedAutoTranslate);
            if (this.isOpenedAutoTranslate) {
                this.$message.success({
                    content: `${this.$t("message.autoTranslate")} ${this.$t("message.on")}`,
                    duration: 3,
                    key: "translate",
                });
            } else {
                this.$message.warning({
                    content: `${this.$t("message.autoTranslate")} ${this.$t("message.off")}`,
                    duration: 3,
                    key: "translate",
                });
            }
        },
        openFullscreen() {
            window.open("?catalog=fullscreen", "_blank");
        },
    },
    computed: {
        ...mapState({
            isCatalogOpen: (state) => state.setting.settings.catalogVisible,
            pageIndex: (state) => state.app.pageIndex,
            getAutoTranslate: (state) => state.chat.autoTranslate,
            visitingPage: (state) => state.app.visitingPage,
            settings: (state) => state.setting.settings,
            loginFormRequired: (state) => {
                const loginFormRequired = state.setting.settings.loginFormRequired;
                const customLoginFormEnabled = state.setting.settings.customLoginFormEnabled;
                const customLoginFormIsValid = !!state.customLoginForm.inputs.filter((x) => x.visible).length;
                if (customLoginFormEnabled && !customLoginFormIsValid) {
                    return false;
                } else {
                    return loginFormRequired;
                }
            },
        }),
    },
    watch: {
        volume() {
            this.emitFunc("localVolume", false, this.volume);
        },
    },
    mounted() {
        this.isVisible = true;
        this.mouseEvent();
        this.isOpenedAutoTranslate = this.getAutoTranslate;
        const keydownCallback = (e) => {
            if (e.key === "Escape") {
                this.$emit("closePopup");
            }
        };

        setTimeout(() => {
            const clickCallback = (e) => {
                const el = document.getElementById("headerOptions");
                log("clickCallback", el?.contains(e.target), el);
                if (el && !el.contains(e.target)) {
                    this.$emit("closePopup");
                }
            };

            document.addEventListener("keydown", keydownCallback);
            document.addEventListener("click", clickCallback);

            this.cancels.push(() => {
                document.removeEventListener("keydown", keydownCallback);
                document.removeEventListener("click", clickCallback);
            });
        }, 100);
    },
    beforeDestroy() {
        this.cancels.forEach((cb) => cb());
    },
};
</script>

<style lang="scss">
#headerOptions {
    position: absolute;
    background-color: #fff;
    border-radius: 4px;
    border: 0.5px solid var(--lang-list-secondary);
    overflow: hidden;
    color: #000000;
    min-width: 230px;
    top: 28px;
    right: -3px;
    box-shadow: 0px 0px 11px 0px #00000014;
    z-index: 99;

    .options {
        background-color: #fff;
        padding: 10px 0px;
        display: flex;
        flex-direction: column;

        .row-item:last-child {
            border-bottom: none;
        }

        .row-item {
            display: flex;
            width: 100%;
            padding: 3px 5px;
            align-items: center;
            //border-bottom: 1px solid #eee;
            cursor: pointer;
            user-select: none;
            transition: 300ms;

            &:hover {
                background-color: #b9e7ef;
            }

            .svg-wrapper {
                margin-right: 15px;
            }

            .text-wrapper {
                font-size: 12px;
                font-weight: 400;
                line-height: 18px;
                letter-spacing: 0em;
                text-align: left;
            }

            .switcher-container {
                margin-left: 15px;
            }

            .volume-switch {
                width: 100%;

                .ant-slider {
                    margin: 0 !important;
                    padding: 0 !important;
                }

                .ant-slider-rail {
                    height: 14px !important;
                    border-radius: 8px;
                }

                .ant-slider-track {
                    height: 14px !important;
                    background-color: var(--button-color) !important;
                    border-radius: 8px;
                }

                .ant-slider-handle {
                    width: 14px !important;
                    height: 14px !important;
                    border: none !important;
                    transform: translateX(-80%) !important;
                    margin-top: 0px !important;
                    box-shadow: 0px 0px 10px 0px #00000019 !important;

                    &:focus {
                        box-shadow: 0px 0px 10px 0px #00000019 !important;
                    }
                }

                .ant-slider-handle-click-focused {
                    box-shadow: 0px 0px 10px 0px #00000019 !important;
                }
            }

            .ant-switch-checked {
                background-color: var(--button-color);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/HeaderOptions.vue